import React, { useCallback, useEffect, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import NavigationHeder from '../../Navigations/NavigationHeder';
import ButtonNew from '../../inc/ButtonNew';
import AgGridNew from '../../grid/ag/ag-grid-new';
import CredentialStoreFormsPopup from './CredentialStoreFormsPopup';
import { useNavigate } from 'react-router-dom';
import Api from '../../../inc/Api';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Settings from '../../../inc/Settings';
import Helper from '../../../inc/Helper';
import { getLabelFromDropdown, gridLinkValueFormat, maskedTextFormatter } from '../../grid/ag/commonFunctions/GridCommonFunctions';
import DatepickerFunctions from '../../../inc/DatepickerHelper';
import CommonAPICalls from '../Common Integration Calls/CommonApiCalls';
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown';

let gridApi = null;
const CredentialStoreFormsListings = () => {
  const [openPopupView, setOpenPopupView] = useState(false);
  const [appMaster, setAppMaster] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {  
    fetchDataForAppMaster();
  }, [])

  const fetchDataForAppMaster = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemAppMasterResponse = await apiCalls.getSystemApiDetails();
      if (systemAppMasterResponse) {
        setAppMaster(systemAppMasterResponse);
      };
    } catch (error) { 
      setAppMaster([]); 
    }
  }
  
  const onClickRedirectToDetailView = (event) => {   
    if(event.colDef.field === 'login_id') { 
      navigate(`/edit-credential-store/${event?.data?.credentials_id}`)
    }
  }

  const onClickPopupView = () => {
    setOpenPopupView(true);
  }

  const onDeleteIntegrationDocument = useCallback(async (element) => { 
    let api = Api;
    api.setUserToken();
    
    let delDocument_ID = element?.data?.credentials_id;

    try {
      const res = await api
      .axios()
      .delete(Settings.apiAppUrl+`/credentials/${delDocument_ID}/`)

      const rowNode = gridApi?.getRowNode(delDocument_ID)
      
      if (rowNode) {
        rowNode.setSelected(false)
      }
      
      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApi?.applyServerSideTransaction(transaction) 
      }, 200);

      gridApi?.refreshServerSide({ purge: true })
      gridApi?.deselectAll();
      
      Helper.alert(res?.data?.message || 'Credential store deleted successfully', 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err)
    }
  }, []);

  const reloadParentGrid = () => {
    gridApi?.refreshServerSide({ purge: true });
    gridApi?.deselectAll();
  };
  
  const gridColumnHeaders = [ 
    {field:'login_id', headerName:'User email', cellRenderer: (params) => gridLinkValueFormat(params), editable: false }, 
    {field:'login_password', cellRenderer: maskedTextFormatter, headerName:'Password', editable: false }, 
    {
      field: 'api_master',
      headerName: 'App',
      editable: false, 
      isAllowZero:true,
      cellEditor: SimpleDropdown,
      minWidth:180,  
      cellEditorParams: {
        values: appMaster
      },
      cellDataType:false,
      valueFormatter: (params) => getLabelFromDropdown(params)
    },
    {field:'token', headerName:'Token', editable: false },
    {field:'created_by', headerName:'Created by', editable: false },
    {field:'created_datetime', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : '-', headerName:'Created date time', editable: false },
    {field:'modified_by', headerName:'Modified by', editable: false },
    {field:'modified_datetime', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : '-', headerName:'Modified date time', editable: false }
  ];

  return (
    <div className='container-fluid'>
      <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'Credentials Store'}>
        <ButtonNew onClick={onClickPopupView} title={'New'}  />
      </NavigationHeder>

      <AgGridNew
        apiUrl={Settings.apiAppUrl+'/credentials'} 
        pagination={false}
        columnDefs={gridColumnHeaders} 
        hideAddBtn={true}
        height={500}
        uniqueField={'credentials_id'}
        onCellClicked={onClickRedirectToDetailView}
        handleDeleteSelectedRows={onDeleteIntegrationDocument}
        onGridReady={(params) => gridApi = params?.api} 
        gridId={"credentatials_store_forms_listing_grid"}
      />

      {openPopupView && <CredentialStoreFormsPopup reloadParentGrid={reloadParentGrid} setClosePopupViewModal={setOpenPopupView} />}
    </div>
  )
}

export default (MasterComponentWraper(CredentialStoreFormsListings));